import React from "react";
import { Notification } from "@zambezi/sdk/notification";
import { useTranslation } from "react-i18next";
import { getBrandCodeDomain } from "../utils/utils";

const Confirmation = () => {
  const brand = getBrandCodeDomain();
  const { t } = useTranslation();

  // Set by default FAQ Link
  let FAQ_Link =
    "https://www.natwest.com/support-centre/general-banking-information/general/what-is-browser-autofill.html";
  if (brand === "rbs") {
    FAQ_Link =
      "https://www.rbs.co.uk/support-centre/general-banking-information/general/what-is-browser-autofill.html";
  } else if (brand === "ubn") {
    FAQ_Link =
      "https://www.ulsterbank.co.uk/support-centre/general-banking-information/general/what-is-browser-autofill.html";
  } else if (brand === "natwesti") {
    FAQ_Link =
      "https://www.natwestinternational.com/support-centre/general-banking-information/general/what-is-browser-autofill.html";
  }

  return (
    <div className="text-center">
      <div className="close-container">
        <div className="icon-prop closebrowser-img"></div>
      </div>
      <h1
        className="not-authorized"
        aria-describedby={t("Close this page and go back to your app.")}
      >
        {t("Close this page and go back to your app.")}
      </h1>
      <Notification
        className="zb-notification-inside-card"
        status="info"
        size="small"
        withStatusBackground={true}
        withStatusBorder={true}
        withBackground={false}
      >
        {t(
          "Just a heads up: To save your details, enable “Autofill” or “Save payment methods” on your device or browser. You can also check or remove saved card details here."
        )}
      </Notification>
      <h1>
        <a
          className="faq"
          aria-describedby={t("FAQ")}
          href={FAQ_Link}
          target="_blank"
          aria-label={t(
            "Any questions? Take a look at our FAQs opens in new tab"
          )}
          rel="noreferrer"
        >
          {t("Any questions? Take a look at our FAQs here")}
        </a>
      </h1>
    </div>
  );
};
export default Confirmation;
